module.exports = __webpack_public_path__ + "Roboto-BlackItalic.1f37c7545ae9f63d2279.svg";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-BlackItalic.svg
// module id = 67
// module chunks = 11